import React from "react"
import {TenantResponse} from "../dtos/tenantResponse"

export const TenantsContext = React.createContext({
	tenants: [] as TenantResponse[],
})
